import React from 'react'
import { observer } from 'mobx-react'
import Modal from 'react-modal'
import usePortManager from '../hooks/use-port-manager'
import useSettingsManager from '../hooks/use-settings-manager'
import Tip from './Tip'

function CalculateRoofAngle (props) {
  const _name = props.name
  const settings_manager = useSettingsManager()
  const _settings = settings_manager.getInputSettings(props.name)
  const strings = typeof _settings === 'object' ? _settings : { title: props.name }

  const port_manager = usePortManager()

  const [modalIsOpen, setIsOpen] = React.useState(false)
  const [numbers, setNumbers] = React.useState({
    height1: 0,
    height2: 0,
  })

  const setHeight1 = function (value) {
    let _numbers = numbers
    _numbers.height1 = parseInt(value)
    setNumbers(_numbers)
  }
  const setHeight2 = function (value) {
    let _numbers = numbers
    _numbers.height2 = parseInt(value)
    setNumbers(_numbers)
  }

  const openModal = function () {
    setIsOpen(true)
  }
  const closeModal = function () {
    setIsOpen(false)
  }

  const calculateStoreAndClose = function () {
    port_manager.updateValue('roof_angle', calculate())
    closeModal()
  }

  const calculateBottomAngle = function (height1, height2) {
    return Math.abs(Math.atan((height2 - height1) / 200) * 180 / Math.PI)
  }

  const calculate = function () {
    let result = Math.round(calculateBottomAngle(numbers.height1, numbers.height2))
    return result + '' // To string so it can be used in input field
  }

  const isValidToolTip = function (obj) {
    if (typeof obj !== 'object') return false
    if (!obj.hasOwnProperty('type')) return false
    if (typeof obj.type !== 'string') return false
    if (obj.type === 'none') return
    return true
  }

  const tip = isValidToolTip(strings.tooltip) ? <Tip settings={strings.tooltip}/> : null

  return (
    <React.Fragment>
      <button onClick={openModal}
              className={'heading calculate-button'}>{settings_manager.getOtherSettings('roofcalc_open_button', 'Beregn')}</button>
      <Modal
        isOpen={modalIsOpen}
        shouldCloseOnOverlayClick={true}
        onRequestClose={closeModal}
        className={'calculate-roof-angle'}
      >
        <div className={'tip-modal-content form'}>
          <div className={'modal__title'}>
            <h3>{settings_manager.getOtherSettings('roofcalc_title', 'Beregn taghældning')}</h3>
            {tip}
          </div>

          <div className={'input-field'}>
            <label
              htmlFor="cra-field-height1">{settings_manager.getOtherSettings('roofcalc_field_height1', 'Højde 1 (cm)')}</label>
            <input id={'cra-field-height1'} type="number" onChange={(e) => setHeight1(e.target.value)}/>
          </div>
          <div className={'input-field'}>
            <label
              htmlFor="cra-field-height2">{settings_manager.getOtherSettings('roofcalc_field_height2', 'Højde 2 (cm)')}</label>
            <input id={'cra-field-height2'} type="number" onChange={(e) => setHeight2(e.target.value)}/>
          </div>
          <button onClick={calculateStoreAndClose}
                  className={'button primary'}>{settings_manager.getOtherSettings('roofcalc_calculate_button', 'Beregn og indsæt')}</button>
        </div>
      </Modal>
    </React.Fragment>
  )
}

export default observer(CalculateRoofAngle)